import axios from "axios";

let userAccess;

export const getUserPermissions = async (token, userId) => {
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const params = {
        uid: userId
    };
    let urlPath = '/api/v2/permissions';
    if (userId) {
        try {
            if (!userAccess) {
                const permissionResp = await axios.get(
                    `${process.env.REACT_APP_SERVERLESS_API_URL}${urlPath}`,
                    {
                        headers: headers,
                        params: params,
                    }
                );
                if (permissionResp && permissionResp.data) {
                    userAccess = permissionResp.data;
                }
            }
            return userAccess;
        } catch (error) {
            console.log(error.message);
            return error.message;
        }
    }
}

export const isAuthorized = (appControlBeingAccessed) => {
    if (userAccess && userAccess.permissions && userAccess.permissions.length) {
        if (userAccess.permissions.includes('trade_eval_accounts')) {
            if (
                appControlBeingAccessed === 'connectionScreen' ||
                appControlBeingAccessed === 'tradeScreen' ||
                appControlBeingAccessed === 'tradeEvaluationAccount'
            ) {
                return true;
            }
        }
        if (userAccess.permissions.includes('trade_paid_accounts')) {
            if (appControlBeingAccessed === 'tradePaidAccount') {
                return true;
            }
        } 
        if (userAccess.permissions.includes('trade_live_accounts')) {
            if (appControlBeingAccessed === 'tradeLiveAccount') {
                return true;
            }
        }
    }
    return false;
    
}